<template>
    <section class="Section">
        <div class="Container">
                <div class="BoxWide">
                    <h5>Piano di manutenzione</h5>
                    <div class="TabellaGenerale"> 
                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                            <tbody>
                                <tr>
                                    <th scope="col">Tipo Pianificazione</th>
                                    <th scope="col">Descrizione attività</th>
                                    <th scope="col">Tipologia di frequenza</th>
                                    <th scope="col">Frequenza temporale</th>
                                    <th scope="col">Data Prossima Prevista</th>
                                    <th scope="col">Data ultima manutenzione</th>
                                    <th scope="col">Responsabile</th>
                                    <th scope="col">Documento</th>
                                </tr>
                                <!-- Inizio repeater -->
                                <RigaGrigliaPianoDiManutenzione v-for="(piano,index) in this.listaPianoDiManutenzioneShow" :key="index" :rigaPianoDiManutenzione="piano" :index="index"> </RigaGrigliaPianoDiManutenzione>
                                <!-- Fine repeater -->
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>         
    </section>
</template>

<script>

import RigaGrigliaPianoDiManutenzione from "@/components/RigaGrigliaPianoDiManutenzione.vue";

export default{
    name: "GrigliaPianoDiManutenzione",
    data(){
        return {
            listaPianoDiManutenzioneShow: null
        }
    },

    components:{
        RigaGrigliaPianoDiManutenzione
    },

    props:{
        listaPianoDiManutenzione: Array
    },

    watch:{
        listaPianoDiManutenzione: function(newValue){
            this.listaPianoDiManutenzioneShow = newValue;
        }
    }
}
</script>